import {ICashbox, ICashboxListItem, ICashboxResponseType} from "@/entity/finance/cashbox/cashbox.types";

export default class Cashbox implements ICashbox {
    total: number;
    data: ICashboxListItem[] = [];
    constructor(data: ICashboxResponseType) {
        this.total = data.total;
        if(!data.data) return
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}